import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<{
  expanded: boolean;
  sidebarOpened: boolean;
}>()(({ tokens, transitions }, { expanded, sidebarOpened }) => ({
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: tokens.spacing['8'],
    borderRadius: tokens.radius.s,
    overflow: 'hidden',
    cursor: 'pointer',
    userSelect: 'none',
    '&:hover': {
      backgroundColor: tokens.colors.bg.greyscale.secondary,
    },
  },

  activeParent: {
    backgroundColor: tokens.colors.accent.bg.blue,
    '&:hover': {
      backgroundColor: tokens.colors.accent.bg.blue,
    },
  },

  submenu: {
    '& .MuiMenu-paper': {
      '& .MuiList-root': {
        pointerEvents: 'auto',
        maxWidth: '300px',
      },

      '&::-webkit-scrollbar': {
        width: 0,
      },
    },
  },

  absoluteIcon: {
    position: 'absolute',
    fontSize: tokens.typography.variant.caption.fontSize,
    display: 'flex',
    top: tokens.spacing['12'] + tokens.spacing['2'],
    left: tokens.spacing['24'] + tokens.spacing['4'],
  },

  menuItemTitleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: `${tokens.spacing['8']}px ${tokens.spacing['16']}px ${tokens.spacing['4']}px`,
  },

  menuItemExpandIcon: {
    flexShrink: 0,
    transform: `rotate(${expanded ? 180 : 0}deg)`,
    transition: `transform ${transitions.easing.easeInOut} 0.5s`,
    marginLeft: tokens.spacing[sidebarOpened ? '12' : '8'],
    marginRight: sidebarOpened ? undefined : tokens.spacing['8'],
  },

  popOverRoot: {
    pointerEvents: 'none',
  },
}));
